module.exports = __webpack_public_path__ + "static/200512_RL_for_dialogues.4b833efc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/teaching_slides/200512_RL_for_dialogues.pdf
// module id = 347
// module chunks = 22885490386278